import {useSelector} from 'react-redux';

/**
 * Whether the current user has the admin role.
 * A raw mirror of `state.user.isAdmin` — for the stricter admin-and-not-support
 * check used to gate features, see `useHasAdminRights`.
 * @returns {boolean}
 */
export const useIsAdmin = () => useSelector(state => state.user.isAdmin);
